module.exports = __webpack_public_path__ + "img/3_116.a6315337.png";